// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  DIRECTUS_API_URL: 'https://tutorial-uat.certiplate.com/items',
  DIRECTUS_ASSET_URL: 'https://tutorial-uat.certiplate.com/assets',
  DIRECTUS_API_TOKEN: 'ulzHH1E-2KGDiFxPrTQh8JMXpEP3RE83',
  SUPPORT_EMAILS: {
    NAVRITI: 'support@navriti.com',
    CERTIPLATE: 'support@certiplate.com'
  },
  APP_CONSTANTS: {
    EMAIL: 'support@certiplate.com',
    PHONE: '+919980456565'
  },
  /*-------------------------------------------------------------------------------------------------*/
  DATE_FORMAT: 'DD-MMM-YYYY',
  LOCALE: 'en-IN',

  /*-------------------------------------------------------------------------------------------------*/
  DEFAULT_VISIBILITY_IDS: [8, 21],
  FRESHDESK_API: 'https://navrititechnologies.freshdesk.com/api/v2/tickets',
  FRESHDESK_API_SEARCH:`https://navrititechnologies.freshdesk.com/api/v2/search/tickets`,
  SUB_MENU_IDS: [19],
  version: require('../../package.json').version,
  EDITOR_API_KEY: 'rcs2ne9ddapicjwo91rxce0hzf4jmzfgb4rihlvodi3diojx',
  FRESHDESK_API_KEY: 'RvQIWCMQGbniINTzXxaD',
  FEEDBACK_FORM: 'https://navriti.freshdesk.com/widgets/feedback_widget/new?&widgetType=embedded&submitThanks=++++++++&searchArea=no',
  LANGUAGE_DETECTION_API_KEY: 'dev-ffa85ce4-d8af-4232-97b0-2a7d5aec7c45'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
